import styled from 'styled-components';

import { Modal, Table, DropdownItem } from 'reactstrap';

import DatePicker from 'react-datepicker';
import { ArrowContainer } from '~/pages/Operation/styles';
import { Dropdown } from 'takeat-design-system-ui-kit';

export const DisplayNoneImprimir = styled.button`
  display: none;
`;

export const Container = styled.div`
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Takeat-Colors-Primary-Red, #C8131B);
  background: var(--Takeat-Colors-Neutrals-White, #FFF);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14), 0px 0px 2px 0px rgba(0, 0, 0, 0.12);
  height: auto;
`;

export const ContainerTr = styled.tr`
  border: none;
  td {
    border: none;
  }
`;

export const TdStyled = styled.th`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 16px;
  align-self: stretch;

  padding: ${({ $buttonOptionsQuit }) => ($buttonOptionsQuit ? '12px 16px 12px 0px' : '12px 16px 12px 8px')};
  justify-content: ${({$buttonOptionsQuit}) => ($buttonOptionsQuit ? 'flex-end' : 'center')};

`;

export const ArrowStyled = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
`

export const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`

export const NameAccount = styled.span `
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  color: var(--Takeat-Colors-Neutrals-Black, #000) !important;
  text-overflow: ellipsis;

  /* Title/Title Small/Medium | 500 */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: 0.15px;
`

export const TextNumberContainer = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);
  text-align: center;

  /* Title/Title Small/Medium | 500 */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: 0.15px;
  flex: 1 0 0;
`


export const Card = styled(Table)`
  width: 100%;

  align-items: center;
  border-radius: 7px;
  border-collapse: separate;

  background: #fff;

  thead {
    border-bottom: 30px solid transparent;
    text-align: left;
    border-top: none;
    tr {
      border: none;
      th {
        button {
          border: none;
          background-color: transparent;
          font-weight: bold;
          color: #333;
        }
      }
      th:last-child {
        text-align: right;
      }
    }
  }
  tbody {
    tr {
      border-bottom: none;
      td {
        border-bottom: none;
        text-align: left;
      }
    }
    td:last-child {
      text-align: right;
    }
  }
`;

export const DatePickerStyledUnify = styled(DatePicker)`
  height: 44px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.lightGray};
  width: 100%;
  margin-top: 8px;
  &:focus {
    border: 1px solid ${(props) => props.theme.colors.gray};
    border-radius: 8px;
  }
`;

export const ClosedButton = styled.button`
  width: 110px;
  height: 36px;
  color: #979797;
  background: #d9d9d9;
  border-radius: 5px;
  border: none;
  font-weight: bold;
`;

export const DropdownMn = styled(Dropdown) `
  gap: 8px
`


export const DropdownItemStyled = styled(DropdownItem)`
  margin: 0px !important;
  padding: 8px !important;
  gap: 8px !important;
  color: var(--Takeat-Colors-Neutrals-Grey-01, #545454) !important;
  font-family: Poppins !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 16.8px !important; /* 120% */
  letter-spacing: 0.014px !important;

  &:hover {
    border-radius: 4px !important;
    background: var(--Takeat-Colors-Neutrals-White-02, #F6F6F6) !important;
  }
`;

export const InputLine = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 16px;
`;

export const TableArea = styled.div`
  width: 756px;
  overflow: hidden;
  margin-top: 8px;
`;

export const TableStyled = styled.div`
  max-height: 392px;
  overflow-y: auto;
  display: block;
  width: 100%;
  border-radius: 12px;

  table {
    width: 100%;
    border-spacing: 0px 1px;
    border-collapse: separate;
    background-color: #ededed;

    thead {
      position: sticky;
      top: 0;
      z-index: 0;
      background-color: #ededed;

      tr {
        display: table;
        width: 100%;
        table-layout: fixed;

        th {
          text-align: center;
          font-weight: bold;
          padding: 4px 12px;
          font-size: 14px;
          font-weight: 600;
        }
      }
    }

    tbody {
      display: block;
      max-height: 300px;
      overflow-y: auto;

      tr {
        display: table;
        table-layout: fixed;
        width: 100%;

        td {
          text-align: center;
          background-color: #fff;
          padding: 16px;
          font-size: 14px;
          font-weight: 500;

          &:first-child {
            border-left: 1px solid #ededed;
          }

          &:last-child {
            border-right: 1px solid #ededed;
          }
        }
      }

      tr:last-child td:first-child {
        border-bottom-left-radius: 8px;
      }

      tr:last-child td:last-child {
        border-bottom-right-radius: 8px;
      }
    }
  }

  tbody::-webkit-scrollbar {
    width: 7px; /* Define a largura da scrollbar */
  }
`;

export const StyledModal = styled(Modal)`
.modal-content {
  display: flex;
  padding: 8px;
  flex-direction: ${({$EditAccount}) => ($EditAccount ? 'column' : 'row')};
  width: ${({$EditAccount}) => ($EditAccount ? '100%' : '50vw')};
  align-items: flex-end;
  gap: 10px;
  align-self: stretch;
  border-radius: 12px;
  background: #FFF;
  margin-left: ${({$EditAccount}) => ($EditAccount ? '0px' : '-170px')};
  }
`

export const StyledModalCommand = styled(Modal)`
  .modal-content {
    width: 788px;
    max-height: 90vh;
    overflow-y: auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-left: -120px;
  }

  .modal-header {
    padding: 16px;
    padding-bottom: 0px;

    .modal-title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      align-items: center;
    }
  }

  .modal-body {
    padding: 16px;
    flex: 1;
  }

  .modal-footer {
    padding: 16px;
  }
`;
export const InfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;

  p {
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 142.857% */
    letter-spacing: 0.15px;
    color: #545454 !important;
  }

  span {
    display: flex;
    height: 40px;
    padding: 10px 16px;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    border-radius: 8px;
    background: #f6f6f6;
  }
`;

export const TotalBill = styled.span`
  display: flex;
  height: 40px;
  padding: 10px 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  background: #f6f6f6;
`;

export const TitleHeader = styled.p`
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;

export const InfoUserBody = styled.div `
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: #FFF;
`

export const BodyConsumption = styled.div`
  max-height: ${(props) => (props.isOpen ? 'auto' : '0')};
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
  overflow: hidden;
  transition: opacity 0.7s ease;
  display: flex;
  padding: ${(props) => (props.isOpen ? '0px 8px 8px 8px' : '0px 8px 0px 8px')};
  justify-content: center;
  align-items: center;
  align-self: stretch;
`

export const Wrapper = styled.div`
  display: flex;
`

export const InputTableStyled = styled.table`
  width: 100%;
  border-spacing: 0px 1px; /* Espaço entre linhas */
  border-collapse: separate; /* Permite usar border-spacing */
  background-color: #f4f4f4;
  border-radius: 8px;
  overflow: hidden; /* Garante que os cantos arredondados sejam visíveis */

  thead {
    tr {
      th {
        text-align: center;
        font-weight: bold;
        padding: 16px;

        &:first-child {
          text-align: left;
        }

        &:last-child {
          text-align: right;
        }
      }
    }
  }

  tbody {
    tr {
      background-color: #fff;
      td {
        text-align: center;
        background-color: #fff;
        padding: 16px;
        background-color: transparent; /* herda do tr */
        color: var(--Takeat-Colors-Neutrals-Black-01, #222);
        text-align: center;

        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
        letter-spacing: 0.1px;


        &:first-child {
          border-left: 1px solid #ededed;
          text-align: left;
        }

        &:last-child {
          border-right: 1px solid #ededed;
          text-align: right;
        }
      }
    }
  }

  tbody tr:last-child td:first-child {
    border-bottom-left-radius: 8px;
  }

  tbody tr:last-child td:last-child {
    border-bottom-right-radius: 8px;
  }
`;

export const ConsumerValue = styled.span `
display: flex;
width: 133px;
padding: 10px var(--Button-Padding-Padding, 24px);
justify-content: center;
align-items: center;
gap: 8px;
color: var(--Takeat-Colors-Neutrals-Black-01, #222);
border-radius: 12px;
background: ${({$negative}) => ($negative ? 'var(--Takeat-Colors-Red-Variations-01, #E5A1A4)' : 'var(--Takeat-Colors-Green-Variations-01, #BCE3DE)')};

/* Label/Label Large/Semibold | 600 */
font-family: Poppins;
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 20px; /* 142.857% */
letter-spacing: 0.1px;
`

export const HeaderForm = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 16px 16px 8px 16px;
  gap: 10px;

`

export const TitleSale = styled.span`
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; 

  font-size: ${({ $titleModal }) => ($titleModal ? '18px' : '16px')};
  letter-spacing: ${({ $titleModal }) => ($titleModal ? 'letter-spacing: var(--Headline-Small-Tracking, 0px)' : '0.15px')};
  color: ${({ $titleModal }) => ($titleModal ? 'var(--Takeat-Colors-Neutrals-Black-01, #222)' : 'var(--Takeat-Colors-Neutrals-Grey-01, #545454)')} !important

`

export const FormFields = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 16px;

  padding: ${({$tooltip}) => ($tooltip ? '0px 8px 8px' : '8px')};
  border-bottom: ${({$tooltip}) => ($tooltip ? '1px solid #EDEDED' : '')}
`
export const FieldInput = styled.div`
  display: flex;
  width: 100%;
  gap: 5px;

  flex-direction: ${({$buttonNfc}) => ($buttonNfc) ? 'row' : 'column'};
  align-items: ${({$buttonNfc}) => ($buttonNfc) ? 'center' : 'flex-start'};
  margin-top: ${({$buttonNfc}) => ($buttonNfc ? '10px' : '')};
  padding-left: ${({$buttonNfc}) => ($buttonNfc ? '8px' : '')}
`

export const BodyModal = styled.div`
  display: flex;
  width: 100%;
  padding: 0px 8px;
  flex-direction: row;
  /* align-items: center; */
  align-self: stretch;
  background: #FFF;
  gap: 10px;
`

export const TextTooltip = styled.span `
color: var(--Takeat-Colors-Neutrals-Grey-02, #7A7A7A);

font-family: Poppins;
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 16px; /* 133.333% */
letter-spacing: 0.5px;
`
export const FooterModal = styled.div `
  display: flex;
  padding: 12px 8px 12px 16px;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  align-items: center;
`

export const ToolTipModal = styled.div ``

export const ModalBodyy = styled.div`
  display: flex;
  padding: 0px 8px;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  background: #FFF;
`

export const TitleCheckbox = styled.span`
  font-family: Poppins;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  vertical-align: middle;
  color: var(--Takeat-Colors-Neutrals-Grey-01, #545454) !important;
`

export const QuitModal = styled.div`
width: 100%;
`

export const HeaderModalForm = styled.div`
width: 100%;
`


export const Nfc = styled.div`
display: flex;
flex-direction: column;
width: 100%;
border-left: 1px solid #EDEDED;
padding-left: 5px;
`
